import type { FunctionComponent } from "react";

import { useSearchContext } from "scmp-app/components/search/contexts";
import { DropdownMenu } from "scmp-app/components/search/search-result-panel/components/dropdown-menu";
import { SortingMenuContainer } from "scmp-app/components/search/search-result-panel/search-result-list/sorting-menu/style";

import { DefaultSortingOption, SortingOptions } from "./const";

type Props = {
  className?: string;
};

export const SearchResultListSortingMenu: FunctionComponent<Props> = ({ className }) => {
  const { orderBy, setOrderBy } = useSearchContext();

  const selectedSortingOption = orderBy ?? DefaultSortingOption.value;

  return (
    <SortingMenuContainer className={className}>
      <DropdownMenu
        onOptionSelect={selectedOrderByOption => {
          if (selectedOrderByOption?.value) {
            setOrderBy?.({
              ...selectedOrderByOption.value,
            });
          }
        }}
        options={SortingOptions}
        selectedOptionValue={selectedSortingOption}
      />
    </SortingMenuContainer>
  );
};

SearchResultListSortingMenu.displayName = "SearchResultListSortingMenu";
